<template>
  <div class="step-navigation" :style="windowPosition" @mousedown="dragStart($event)" @mousemove="drag($event)" @mouseup="isDragging = false">
    <h3>Scenario Navigation</h3>
    <div>
      <div>Language:</div>
      <div class="languages">
        <span :class="lang === 0 ? 'active' : ''" @click="setLanguage({value: 0})">En</span>
        <span :class="lang === 1 ? 'active' : ''" @click="setLanguage({value: 1})">Fr</span>
        <span :class="lang === 2 ? 'active' : ''" @click="setLanguage({value: 2})">De</span>
        <span :class="lang === 3 ? 'active' : ''" @click="setLanguage({value: 3})">It</span>
        <span :class="lang === 4 ? 'active' : ''" @click="setLanguage({value: 4})">Ru</span>
      </div>
    </div>
    <div>
      <div>Type:</div>
      <div class="languages">
        <span :class="layer === 0 ? 'active' : ''" @click="setLayer({value: 0})">Netwrix Auditor</span>
        <span :class="layer === 1 ? 'active' : ''" @click="setLayer({value: 1})">NDC</span>
      </div>
    </div>
    <div>
      <div>
        Current Scenario:
      </div>
      <div>
        <span>{{currentScenario}}</span>
      </div>
    </div>
    <div>
      <div>
        Current Screen:
      </div>
      <div>
        <span>{{currentScreen}}.vue</span>
      </div>
    </div>
    <div>
      <div>
        Current Step:
      </div>
      <div>
        <span>{{currentStep + 1}}</span> of <span>{{steps}}</span>
      </div>
    </div>
    <div class="stepper">
      <div v-for="(step, index) in steps" :key="index" :class="{'active': currentStep === index}" @click="goToStep(index)">
        {{index + 1}}
      </div>
    </div>
    <div>
      <button @click="blocked ? unlockApp() : lockApp()">
        <span v-if="!blocked">Hide Tooltip</span>
        <span v-else>Show Tooltip</span>
      </button>
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex';
  import {mapActions} from 'vuex';

  export default {
    name: "StepNavigation",
    data() {
      return {
        isDragging: false,
        position: {
          top: 0,
          left: 1520,
        },
        clickPosition: {
          top: 0,
          left: 0,
        },
        diff: {
          top: 0,
          left: 0,
        },
      }
    },
    computed: {
      ...mapState('guide', ['currentScenario', 'currentStep', 'currentScreen', 'lang', 'layer', 'blocked']),
      steps() {
        return this.$store.getters['guide/totalSteps'];
      },
      windowPosition() {
        return {
          top: `${this.position.top}px`,
          left: `${this.position.left}px`,
        }
      },
    },
    methods: {
      ...mapActions('guide', ['goToStep', 'setLanguage', 'setLayer', 'unlockApp', 'lockApp']),
      dragStart(e) {
        this.isDragging = true;
        this.diff.left = this.position.left - e.clientX;
        this.diff.top = this.position.top - e.clientY;

        this.clickPosition.left = e.clientX;
        this.clickPosition.top = e.clientY;
      },
      drag(e) {
        if (this.isDragging === true) {
          this.position.left = e.clientX + this.diff.left;
          this.position.top = e.clientY + this.diff.top;
        }
      },
      stopDrag() {
        this.isDragging = false;
      },
    },
    mounted() {
      window.addEventListener('mouseup', this.stopDrag);
    }
  }
</script>

<style lang="less" scoped>
  .step-navigation {
    width: 400px;
    position: fixed;
    top: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.7);
    color: #fff;
    padding: 20px;
    border-radius: 0 0 0 3px;
    z-index: 100;
    cursor: move;
    cursor: -webkit-grab;
    cursor: -moz-grab;
    cursor: grab;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;

    & > div {
      margin: 10px 0;

      button {
        background: rgb(75, 200, 95);
        border: none;
        width: 120px;

        span {
          color: #fff;
        }
      }

      span {
        color: rgb(75, 200, 95);
        font-weight: bold;
      }
    }

    .languages {
      span {
        min-width: 28px;
        text-align: center;
        display: inline-block;
        margin-right: 5px;
        color: #888;
        cursor: pointer;
        border: 1px solid #888;
        padding: 0 4px;
        margin-top: 5px;

        &.active {
          cursor: default;
          background: #4bc85f;
          border: 1px solid #4bc85f;
          color: #fff;
        }
      }
    }

    .stepper {
      & > div {
        width: 24px;
        height: 24px;
        background: rgba(125, 125, 125, 0.5);
        color: #fff;
        font-weight: bold;
        font-size: 12px;
        text-align: center;
        border-radius: 50%;
        display: inline-block;
        margin: 2px;
        cursor: pointer;
        padding: 3px 0;

        &:hover {
          background: rgba(200, 200, 200, 0.5);
        }

        &.active {
          background: rgba(0, 125, 0, 0.5);
        }
      }
    }
  }
</style>